import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'app/_services/notification.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SignalRService } from '../../_services/signalr.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { UserLoginResponse } from './_models/userLoginResponse';
import { AccountService } from '../account.service';

declare const crisp: any;

@Component({
    selector: 'login', templateUrl: './login.component.html', styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
    loginForm: UntypedFormGroup;
    showPassword = false;
    isLoading = false;

    constructor(private accountService: AccountService,
        private notificationService:  NotificationService,
        private signalRService: SignalRService,
        private activatedRoute: ActivatedRoute,
        private formBuilder: UntypedFormBuilder,
        private ngxLoader: NgxUiLoaderService)
    {
        crisp.hide();
    }

    ngOnInit() {
        // Finaliza o signalR
        this.signalRService.finalizar();
        this.ngxLoader.stopLoader('loader-principal');

        this.loginForm = this.formBuilder.group({
            login: ['', Validators.required],
            senha: ['', Validators.required]
        });

        this.accountService.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
    }

    login() {
        if (this.loginForm.invalid)
            return;

        this.isLoading = true;

        this.accountService.login(this.loginForm.controls.login.value, this.loginForm.controls.senha.value).subscribe({
            next: async (response: ApiResponseModel<UserLoginResponse>) => {
                var success = await this.accountService.handleLogin(response.result);
                this.isLoading = false;

                if (!success)
                    this.handleLoginFailed();
            },
            error: () => {
                this.isLoading = false;
                this.handleLoginFailed();
            }
        });
    }

    private handleLoginFailed(): void {
        this.notificationService.showErrorToastr('login.mensagens.usuario-senha-invalido', { translateMessage: true });
        this.loginForm.controls.senha.setValue('');
    }

    toggleShowPassword() {
        this.showPassword = !this.showPassword;
    }
}
